module.exports = "mutation UpdateAttributeGroup($group:UpdateAttributeGroupInput!){updateAttributeGroup(group:$group){success}}"